module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image01-2da467d08f11d5654fdf01f2af2675ef.jpeg";